import countries from "i18n-iso-countries";
import * as enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

export function getCountryCode(countryName: string): string | undefined {
  return countries.getAlpha2Code(countryName, "en");
}
